import { useState } from 'react';

const useSubject = (initialValue) => {
  const [subject, setSubject] = useState(initialValue);
  const [validate, setValidate] = useState(false);
  const handleChange = (e) => {
    setSubject(e);
    if (e.length == 0) {
      setValidate(true);
    } else {
      setValidate(false);
    }
  };

  return [subject, validate, handleChange];
};

export default useSubject;
